import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Page from 'src/components/Page';
import { createInsurerAction } from 'src/store/actions/catalogActions';
import { useTranslation } from 'react-i18next';
import InsurersList from './InsurerList';
import InsurerForm from './InsurerForm';
import Toolbar from '../Toolbar';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const InsurersListView = () => {
  const { classes }  = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  const handleClose = useCallback(() => {
    setOpen(false);
    setData(null);
  }, [setOpen, setData]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleCreate = useCallback(
    values => {
      delete values.serviceId;
      dispatch(createInsurerAction(values));
      handleClose();
    },
    [handleClose]
  );

  return (
    <Page className={classes.root} title={t('NAVIGATION.CATALOG_LIST.INSURER')}>
      <Container maxWidth={false}>
        <Toolbar
          catalogLabel={t('NAVIGATION.CATALOG_LIST.INSURER')}
          handleOpen={handleOpen}
        />
        <Box mt={3}>
          <InsurersList />
        </Box>
      </Container>
      <InsurerForm
        open={open}
        data={data}
        handleClose={handleClose}
        handleCreate={handleCreate}
      />
    </Page>
  );
};

export default InsurersListView;
